<nz-layout>
  <nz-content class="centered">
    <div class="centered-box-vertical custom-centered-box" style="max-width: 1920px !important;">
      <img class="logo" src="assets/img/teamsystem.png" />
      <nz-spin [nzSpinning]="isSpinning">
          <div class="centered-div" >
            <h2 class="text-center">{{emailElements.message}}</h2>
            <i nz-icon *ngIf="!isError && !isSpinning" [nzType]="emailElements.icon" nzTheme="outline" style="font-size: 30px; color:green"></i>
            <i nz-icon *ngIf="isError && !isSpinning" [nzType]="emailElements.icon" nzTheme="outline" style="font-size: 30px; color:red"></i>
          </div>
          <br>
          <div class="centered-div-button">
            <button nz-button nzType="default" nzBlock="false" nzSize="large" routerLink="/">
              <i nz-icon nzType="home"></i> Ritorna alla home
            </button>
          </div>
      </nz-spin>
    </div>
  </nz-content>
</nz-layout>
